<template>
    <el-dialog
        :visible.sync="Visible"
        :title="title"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeSelect"
    >
        <el-row>
            <el-col :span="2"
                ><el-button type="primary" @click="selectRow()"
                    >确认</el-button
                ></el-col
            >
            <el-col :span="15">
                <el-input
                    v-model="strFilter"
                    placeholder="快速筛选"
                    v-on:keyup.enter.native="search"
                    ref="searchinput"
                >
                </el-input>
            </el-col>
            <el-col :span="7"
                ><el-button class="el-append-search" @click="search()"
                    >查询</el-button
                >
                <el-button type="primary" @click="selectRow(-1)"
                    >回传空值</el-button
                >
            </el-col>
        </el-row>
        <el-table
            ref="detail"
            :data="tableData"
            size="mini"
            border
            :highlight-current-row="true"
            class="toggletable"
            :row-key="getRowKeys"
            v-loading="loading"
            @selection-change="handleSelectionChange"
        >
            <el-table-column
                type="selection"
                width="55"
                :reserve-selection="true"
            ></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="编码" prop="code"></el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column
                label="单据类型编码"
                prop="typeCode"
                v-if="type == '业务类型' && moduleMark == 'SCM8'"
            ></el-table-column>
            <el-table-column
                label="单据类型名称"
                prop="typeName"
                v-if="type == '业务类型' && moduleMark == 'SCM8'"
            ></el-table-column>
            <el-table-column
                label="所属类别编码"
                prop="typeCode"
                v-if="type == '品项小类' || type == '品项中类'"
            ></el-table-column>
            <el-table-column
                label="所属类别名称"
                prop="typeName"
                v-if="type == '品项小类' || type == '品项中类'"
            ></el-table-column>
        </el-table>
        <pagerBar
            :isInit="false"
            ref="refPagerBar"
            :apiURL="getDataUrl"
            :GetData="initData"
            :queryParam="queryParam"
            :errorFunc="closeOpenloading"
        ></pagerBar>
        <span slot="footer" class="dialog-footer">
            <el-button
                type="info"
                size="medium"
                @click="closeSelect"
                icon="el-icon-close"
                >取 消</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import pagerBar from '@/views/pager/pagerBar'
import config from '../../common/config'
import AjaxHelper from '@/common/js/AjaxHelper'

import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
    components: {
        pagerBar
    },
    data() {
        return {
            isInit: false,
            Visible: false,
            loading: true,
            index: 0,
            type: '',
            title: '',
            queryParam: {},
            newqueryParam: {},
            strFilter: '',
            getDataUrl:
                config.BASE_Middle_API +
                'SubjectDetails/SubjectFieldDataForSelect',
            tableData: [],
            moduleMark: '',
            isformula: false,
            multipleSelection: [],
            selOrder: [],
            allTableData: []
        }
    },
    methods: {
        search() {
            this.newqueryParam.strFilter = this.strFilter.trim()
            this.$refs.refPagerBar.ChangeQueryParam(this.newqueryParam)
        },
        getRowKeys(row) {
            return row.id
        },
        handleSelectionChange(val) {
            const _this = this
            // 如果是反显选中操作 不做处理
            if (this.toggleRowSelect) {
                return
            }
            _this.multipleSelection = val
        },
        getAllTalbeData() {
            const that = this
            AjaxHelper.get(
                config.BASE_Middle_API + 'SubjectDetails/GetSubjectFieldDatas',
                that.newqueryParam
            )
                .then(function (response) {
                    if (response.success) {
                        that.allTableData = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        openMutilSelect(
            index,
            type,
            accountConfInfoValue,
            brandValue,
            moduleMark,
            storeId,
            isMultiOrg,
            isformula,
            value
        ) {
            this.multipleSelection = []
            this.selOrder = []
            this.tableData = []
            this.Visible = true
            this.index = index
            this.type = type
            this.moduleMark = moduleMark
            this.title = '请选择' + type
            this.newqueryParam.fieldName = type
            this.newqueryParam.brandID = brandValue
            this.newqueryParam.accountId = accountConfInfoValue
            this.strFilter = ''
            this.newqueryParam.strFilter = ''
            this.newqueryParam.storeId = storeId
            this.newqueryParam.isMultiOrg = isMultiOrg
            this.isformula = isformula

            this.$nextTick(function () {
                this.$refs.searchinput.focus()
            })
            if (value == undefined) {
                this.multipleSelection = []
            } else {
                this.multipleSelection = value.split(';')
            }
            const that = this
            AjaxHelper.get(
                config.BASE_Middle_API + 'SubjectDetails/GetSubjectFieldDatas',
                that.newqueryParam
            )
                .then(function (response) {
                    if (response.success) {
                        that.allTableData = response.result
                        that.$refs.refPagerBar.ChangeApiURL(
                            that.getDataUrl,
                            that.newqueryParam
                        )
                        that.loading = false
                        that.$nextTick(() => {
                            that.toggleRowSelect = true
                            // tableData当页数据 multipleSelection需要反显的数据（已经选中的）
                            that.$refs.detail &&
                                that.allTableData.forEach((row) => {
                                    let selectRow = that.multipleSelection.find(
                                        (item) => item === row.id
                                    )
                                    if (selectRow != undefined) {
                                        that.$refs.detail.toggleRowSelection(
                                            row,
                                            selectRow ? true : false
                                        )
                                    }
                                    // 注意：toggleRowSelection传的row一定是表格数据中的某一行数据
                                })
                            that.toggleRowSelect = false // 记录是否是反显选中操作，因为选中改变会触发@selection-change事件
                        })
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })

            // this.getAllTalbeData();
        },
        selectRow(index) {
            this.strFilter = ''
            this.Visible = false
            if (index == -1) {
                this.$emit('selectMutilValue', this.index, this.type, null)
            } else {
                this.$emit(
                    'selectMutilValue',
                    this.index,
                    this.type,
                    this.multipleSelection
                )
            }
            this.tableData = []
            this.$refs.detail.clearSelection()
        },
        initData(d) {
            this.tableData = d
            this.$nextTick(() => {
                this.toggleRowSelect = true
                // tableData当页数据 multipleSelection需要反显的数据（已经选中的）
                this.$refs.detail &&
                    this.tableData.forEach((row) => {
                        let selectRow = this.multipleSelection.find(
                            (item) => item === row.id
                        )
                        if (selectRow != undefined) {
                            this.$refs.detail.toggleRowSelection(
                                row,
                                selectRow ? true : false
                            )
                        }
                        // 注意：toggleRowSelection传的row一定是表格数据中的某一行数据
                    })
                this.toggleRowSelect = false // 记录是否是反显选中操作，因为选中改变会触发@selection-change事件
            })
        },
        closeSelect() {
            this.strFilter = ''
            this.Visible = false
            this.$refs.detail.clearSelection()
        },
        closeOpenloading() {
            this.loading = false
        }
    }
}
</script>

<style>
.myshowup.el-button {
    border-radius: 16px;
}
.el-append-search {
    background-color: #409eff !important;
    color: #fff !important;
}
.graybg {
    background: #f9f9f9 !important;
}
</style>
